import styled from 'styled-components';

const LanguageSwitcher = styled.div`
	--borderRadius: var(--sp1x);
	--languagePad: var(--sp1x);

	position: relative;
	z-index: 20;
	width: calc(var(--languagePad) * 2 + var(--p5) * var(--lineHeight) + 2px);
	aspect-ratio: 1;

	.inner-wrapper-language {
		position: absolute;
		top: 0;
		left: 0;
		background-color: var(--backgroundColor);
		border-radius: var(--borderRadius);
	}

	.selected-lang-wrap {
		position: relative;
		display: flex;
		align-items: center;

		.lang-text {
			will-change: transform;
			transform: scale(1);
		}

		.inner-wrapper-language {
			border: 1px solid var(--neutral600);
			border-radius: var(--borderRadius);
			padding: var(--languagePad);
			display: flex;
			flex-direction: column;
		}
	}

	.item-language {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.dropdown {
		overflow: hidden;
		height: 0;
	}

	.inner-wrapper-dropdown {
		display: flex;
		flex-direction: column;
		gap: calc(var(--languagePad) * 2);
		padding-top: calc(var(--languagePad) * 2);
	}

	&.is-dropdown-open {
		z-index: 100002;

		.selected-lang-wrap .inner-wrapper-language {
			position: relative;
			z-index: 100002;
		}
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--languagePad: calc(var(--sp0-5x) + var(--sp0-5x) / 2);
	}
`;

export default LanguageSwitcher;
